
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)  

  if (itemTitle.toLowerCase().indexOf('Fresh Challah collection *REMUERA CAMPUS*'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('Challah *REMUERA CAMPUS*- FRIDAY ONLY'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('Challah Fresh Round plain - REMUERA'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('Challah Fresh Round Raisin - REMUERA'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }   

  if (itemTitle.toLowerCase().indexOf('TKD Speaker Series'.toLowerCase()) > -1) {
    specialProduct2 = true;
  }   
}

if (specialProduct2 === true) {
  CRexcludedFromPickup = true;
}

if (specialProduct1 === true) {
  delete(stores[0]);
} else {
  delete(stores[1]);
}
var disableCheckoutButton2 = function (){
    console.log('Disable checkout')
    var checkoutButtonSelector = document.querySelector('#checkout');
    if (checkoutButtonSelector) {
        checkoutButtonSelector.disabled = true;
    }
}
var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()
if (currentHour >= 15) {
  storePickupSettings.min_days = 3;  
}

var excluded = false;
var dryProduct = false;

var bakery = false;
var notBakery = false;

var campus = false;
var noCampus = false;

var challah = false;
var noChallah = false;

var fresh = false;
var noFresh = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  
  //console.log({itemTitle})  
  console.log('-->', itemCollections)

  if (itemCollections.toLowerCase().indexOf('pesach catering') > -1) {
	 fresh = true;
  } else {
   	noFresh = true;
  }
  
  if (itemCollections.toLowerCase().indexOf('bakery') > -1) {
	 bakery = true;
  } else {
   	notBakery = true;
  }
console.log('test');
  if (itemCollections.toLowerCase().indexOf('Holiday Challah'.toLowerCase()) > -1) {
	 challah = true;
  } else {
   	noChallah = true;
  }
  
  if (itemTitle.toLowerCase().indexOf('Challah *REMUERA CAMPUS*- FRIDAY ONLY'.toLowerCase()) > -1
      || itemTitle.toLowerCase().indexOf('Challah Fresh Round plain - REMUERA'.toLowerCase()) > -1
      || itemTitle.toLowerCase().indexOf('Challah Fresh Round Raisin - REMUERA'.toLowerCase()) > -1
     ) {
	 campus = true;
  } else {
   	noCampus = true;
  }
  
  if (
    itemCollections.toLowerCase().indexOf('rosh hashanah') > -1
    // itemCollections.toLowerCase().indexOf('bakery') > -1
    //  || itemCollections.toLowerCase().indexOf('deli') > -1
    //  || itemCollections.toLowerCase().indexOf('meat') > -1
    //  || itemCollections.toLowerCase().indexOf('cheese') > -1
    //  || itemCollections.toLowerCase().indexOf('frozen') > -1    
    //  || itemCollections.toLowerCase().indexOf('heat@home') > -1    
      
     ) {
    excluded = true;
  } else {
    dryProduct = true;
  }
}

console.log({excluded, dryProduct})


document.addEventListener('crJQActivated', function (e) {
  /*if (excluded === true && dryProduct === true) {
      disableCheckoutButton2();
      jqCR('.special-message').removeClass('hide')
      setTimeout(function(){
        //jqCR('.cr-block-message').text("You will have to create two separate orders one for your perishable products (bakery, deli, chilled & frozen)  and one for all other items.")
        jqCR('.cr-block-message').text("You will have to create two separate orders one for your Rosh Hashanah products and one for all other items.")
      }, 100)
      
      var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);   
  } */ 
//console.log({campus})
  if (specialProduct2 === true) {
    jqCR('#pickup-container').remove()
  }
  if (campus === true) {
    jqCR('.cr-mandatory-for-pickup').css('display', 'none')
    var tt2 = setInterval(function(){
      jqCR('.cr-mandatory-for-pickup').css('display', 'none');}, 100);
    setTimeout(function() { clearInterval(tt2); }, 2000);  
  }
    console.log(campus, noCampus)
  if (campus === true && noCampus === true) {
      disableCheckoutButton2();
      console.log('============')
    
      jqCR('#pickup-container').remove()
      //jqCR('.special-message').removeClass('hide')
      setTimeout(function(){      
        jqCR('.cr-block-message').html(`Fresh Challah is the only product currently available to pick up from the new Remuera campus. Please remove all other items apart from <strong>"Fresh Challah collection *REMUERA CAMPUS*"</strong> in order to proceed. 
<br><br>
For all other deli products please shop online for standard delivery or come into our Greys Avenue shop (110 Greys Avenue, Auckland, 1010 - Mon-Fri 8am-3pm)
<br><br>
We look forward to welcoming you to The NEW Kosher Deli in Remuera later this year!`)
        var checkoutButtonSelector = document.querySelector('#checkout');
console.log(checkoutButtonSelector)        
        if (checkoutButtonSelector) {
console.log('Disable')          
            checkoutButtonSelector.disabled = true;
        }
      }, 100)
      
      var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);   
  }  

  if (challah === true && noChallah === true) {
      disableCheckoutButton2();
      jqCR('#pickup-container').remove()
      jqCR('.special-message').removeClass('hide')
      setTimeout(function(){      
        jqCR('.cr-block-message').html(`Bake@Home challah is only available to pre order. Please remove all other items from your basket and checkout separately to this order`)
      }, 100)
      
      var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);   
  }  

  if (fresh === true && noFresh === true) {
      disableCheckoutButton2();
      jqCR('#pickup-container').remove()
      jqCR('.special-message').removeClass('hide')
      setTimeout(function(){      
        jqCR('.cr-block-message').html(`*Pesach catering is available for collection only. 
<br>
Please remove all non-catering items from your cart. 
<br>
Dry goods can still be ordered online for delivery, or purchased in-store.
<br>
Thanks for your understanding *`)
      }, 100)
      
      var tt = setInterval(function(){disableCheckoutButton2();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);   
  }  
})